module.exports = __webpack_public_path__ + "img/smallest-AI.653315b5.svg";